import styled from "@emotion/styled";
import { Box, Paper, css } from "@mui/material";
import { IEndereco } from "../../../core/interfaces/IEndereco";

export const EnderecoPaperContainer = styled(Box)<{ endereco: IEndereco | undefined }>(({ theme, endereco }) => css`
    min-height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: ${endereco ? "space-between" : "flex-start"};
    color: ${theme.palette.text.secondary};
`)

export const EnderecoInfoBox = styled(Box)`
    display: flex;
    align-items: center;
    flex: 1;
`

export const EnderecoBox = styled(Box)<{ endereco: IEndereco | undefined }>(({ theme, endereco }) => css`
    display: flex;
    flex-direction: column;
    margin-left: 0.7rem;
`)